import React from "react";
import { useContext } from "react";
import { ThemeContext } from "../../pages/qcast-logo";
import logo from "../../assets/mini_logo.png";

export const GetStarted = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] z-[2147483647] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 justify-between px-2 place-items-center py-2 shadow-sm">
        <div className="justify-self-start mr-2 w-[2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col">
          <img alt="" src={logo} />
        </div>
        <p className="font-medium text-[#1E3053] w-fit justify-self-center whitespace-nowrap">
          Getting Started
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 text-sm flex flex-col space-y-3 items-center pt-4 pb-6">
        <h2 className="font-medium text-[#2C3037]">
          Begin your Qcast conversation
        </h2>
        <p className="text-center text-[#2C3037]">
          You can sign in if you already have a Qcast account, or create an
          account below.
        </p>
        <span className="w-full flex flex-col items-center">
          <button
            style={{ backgroundColor: bg, color: font }}
            className="w-2/3 rounded-full p-2 shadow-md"
            onClick={props.signup}
          >
            Sign up
          </button>
          <p className="text-[#515A6B]">or</p>
          <button
            style={{ backgroundColor: bg, color: font }}
            className="w-2/3 rounded-full p-2 shadow-md"
            onClick={props.signin}
          >
            Sign in
          </button>
        </span>
      </div>
    </div>
  );
};
